<template>
  <Layout>
    <Title
      icon="account"
      heading="Your Account"
      sub-heading="Configure Work Categories,
      enabling you to easily manage Statements of Work (SoW)
      relating to that category."
    />
    <div class="container my-4">
      <div class="row">
        <div class="col">
          <h2>Counterparties</h2>
          <p class="lead">Edit Counterparty</p>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row">
        <div class="col-lg-6 offset-lg-3">
          <form @submit.prevent="submit">
            <div class="form-group">
              <TextInput
                v-model="form.name"
                :errors="errors ? errors.name : []"
                type="text"
                autofocus
                autocapitalize="off"
                label="Who is the Counterparty? (Business name)"
                @input="errors.name = []"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <TextInput
                v-model="form.registered_number"
                :errors="errors ? errors.registered_number : []"
                type="text"
                autofocus
                autocapitalize="off"
                label="Registered Number"
                @input="errors.registered_number = []"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <TextArea
                label="Address"
                v-model="form.address"
                :errors="errors ? errors.address : []"
                autofocus
                autocapitalize="off"
                rows="4"
                @input="errors.address = []"
                validateSuccess
                validateError
              />
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-3 flex">
                  <LoadingButton :loading="adding" class="btn btn-primary btn-block" type="submit">
                      {{counterParty ? 'Update' : 'Create'}}
                    </LoadingButton>
                  <button class="btn btn-secondary btn-block" @click.prevent="showAdd = false">
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@/Shared/Layout';
import Title from '@/Shared/Title';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';
import TextArea from '@/Shared/Inputs/Textarea';


export default {
  components: {
    Title,
    Layout,
    LoadingButton,
    TextArea,
    TextInput,
  },

  props: {
    counterParty: {
      type: Object,
      default: null,
    },
    errors: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      adding: false,
      form: this.$inertia.form({
        name: this.counterParty ? this.counterParty.name : '',
        address: this.counterParty ? this.counterParty.address : '',
        registered_number: this.counterParty ? this.counterParty.registered_number : '',
      }),
    };
  },

  methods: {
    submit() {
      this.adding = true;

      if (this.counterParty) {

        this.form.put(this.route('counter-party.update', [this.counterParty.id]), {
          preserveScroll: true,
          onSuccess: () => {
            this.adding = false;
          },
          onError: (error) => {
            this.adding = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          },
        });

      } else {

        this.form.post(this.route('counter-parties.store'), {
          preserveScroll: true,
          onSuccess: () => {
            this.adding = false;
          },
          onError: (error) => {
            this.adding = false;
            this.errors = error.response.data.errors;
            throw new Error(error);
          },
        });
      }
    },
  },
};
</script>
